import Header from "./Header/Header";
import StickHeader from "./StickyHeader/StickyHeader";

const HeaderSection = () => {
    return (
        <>
            {/* <StickHeader/> */}
            <Header />

        </>
    )
}

export default HeaderSection;